module.exports = __webpack_public_path__ + "img/ingredienten-wortels-met-tijm.e8ee2e75.jpeg";